import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useDeleteNewsMutation as deleteNewsMutation } from "@/modules/admin/news/services/__generated__/useDeleteNewsMutation.graphql"

const mutation = graphql`
  mutation useDeleteNewsMutation($deleteNews: DeleteNewsInput!, $connections: [ID!]!) {
    deleteNews(input: $deleteNews) {
      news {
        id @deleteEdge(connections: $connections)
      }
      errors {
        ... on NewsNotFound {
          message
          newsId
        }
      }
    }
  }
`

export function useDeleteNewsMutation() {
  const [commit] = useMutation<deleteNewsMutation>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<deleteNewsMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler] as const
}
